<div class="p-1 w-full overflow-hidden flex-1 bg-gray-1000 text-white" style="height: 20rem">
  <div class="flex flex-row w-full items-center h-full">
    <div
      class="w-full text-center font-semibold flex flex-row items-center gap-x-3 justify-center p-1"
      style="font-size: 13rem"
    >
      <img src="assets/images/5f-logo.svg" width="264" class="inline py-1" /> Trucks Across America
      <!--<mat-form-field class="w-full">
        <mat-label> Search </mat-label>
        <mat-select>
          <mat-option>
            <ngx-mat-select-search
              placeholderLabel="Find Driver"
              noEntriesFoundLabel="No Matching Drivers Found"
              [formControl]="searchBoxControl"
            ></ngx-mat-select-search>
          </mat-option>
          <mat-option
            *ngFor="let driver of searchableDriverList$ | async; trackBy: 'id' | trackByKey"
            (click)="navToDriver(driver)"
            style="min-height: 75px; line-height: 24px; font-size: 14px"
          >
            <div class="grid grid-cols-2">
              <div>{{ driver.name }}</div>
              <div class="text-right">{{ driver.phone | phone }}</div>
              <div>{{ driver.lastUpdated | ago }}</div>
              <div class="text-right text-red-500 font-semibold">
                CONFIDENTIAL - {{ driver.currentCompany || 'n/a' }}
              </div>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>-->
    </div>
    <div>
      <button mat-icon-button (click)="promptFilters()"><mat-icon>filter_alt</mat-icon></button>
    </div>
  </div>
</div>
<div class="w-full">
  <div class="m-1 fixed z-50 left-0 bottom-0 bg-white">
    <button mat-icon-button (click)="navToCurrent()"><mat-icon>my_location</mat-icon></button>
  </div>
  <div class="m-1 fixed z-50 right-0 bottom-0">
    <button mat-raised-button color="primary" (click)="toggleStyle()">Toggle Style</button>
  </div>
  <div #map class="w-full h-full fixed"></div>
</div>

<ng-template #filtersModal>
  <div mat-dialog-title>Filters</div>
  <div mat-dialog-content>
    <mat-form-field class="w-full py-2">
      <mat-label> 5F Drivers </mat-label>
      <mat-select [formControl]="onlyFiveFControl">
        <mat-option [value]="'All'">All</mat-option>
        <mat-option [value]="false">Non-5F</mat-option>
        <mat-option [value]="true">5F</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="w-full py-2">
      <mat-label> Halliburton Drivers </mat-label>
      <mat-select [formControl]="onlyHALControl">
        <mat-option [value]="'All'">All</mat-option>
        <mat-option [value]="false">Non-HAL</mat-option>
        <mat-option [value]="true">HAL</mat-option>
      </mat-select>
      <mat-hint>Exclude or include drivers for Halliburton</mat-hint>
    </mat-form-field>
    <mat-form-field class="w-full py-2">
      <mat-label> Box/Pneumatic Drivers </mat-label>
      <mat-select [formControl]="onlyBoxersControl">
        <mat-option [value]="'All'">All</mat-option>
        <mat-option [value]="false">Pneumatic</mat-option>
        <mat-option [value]="true">Box</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="w-full py-2">
      <mat-label> Last Updated Within </mat-label>
      <mat-select [formControl]="lastUpdatedWithinControl">
        <mat-option [value]="1"> 1 Hour </mat-option>
        <mat-option [value]="24"> 24 Hours </mat-option>
        <mat-option [value]="168"> 7 Days </mat-option>
        <mat-option [value]="720"> 30 Days </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button mat-dialog-close mat-raised-button>Close</button>
  </div>
</ng-template>
